import { Box, Typography } from '@mui/material';
import { Container as StyledContainer } from '../pages/Questionnaire/styles';

export default function FinishView({ payload }) {
  return (
    <StyledContainer style={{ zIndex: 500 }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          flexGrow: 1,
          textAlign: 'center',
          py: 4
        }}
      >
        <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold' }}>
          השאלון הסתיים
        </Typography>

        <Typography variant="h6" dir="rtl" color="text.secondary">
          סיימת את שאלון המיון כולו.
          תודה רבה על השתתפותך.
        </Typography>
      </Box>
    </StyledContainer>
  );
}
